export default __webpack_public_path__ + "static/media/whatsapp-fill.5ceef6f8.svg";